module.exports = __webpack_public_path__ + "static/media/AWEBSERVICES.a7e580cb.png";